(function () {
  function formatMoney(cents, format) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    var value = (Math.abs(cents) / 100).toFixed(2);
    var valueNoDecimals = String(Math.round(Math.abs(cents) / 100));
    var withComma = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (!format) return '$' + value;
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, valueNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, valueNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function perSensor(totalCents, sensors) {
    if (!sensors) return 0;
    return Math.round(totalCents / sensors);
  }

  function savePercent(oneOff, sub) {
    if (!oneOff || oneOff <= 0 || sub >= oneOff) return 0;
    return Math.round(((oneOff - sub) / oneOff) * 100);
  }

  /* NZ: % off shared list (single-sensor × pack). One-time floors (16.68 → 16); subscribe rounds (19.93 → 20). */
  function percentOffList(listCents, actualCents, roundMode) {
    if (!listCents || actualCents >= listCents) return 0;
    var raw = ((listCents - actualCents) / listCents) * 100;
    return roundMode === 'floor' ? Math.floor(raw) : Math.round(raw);
  }

  function moneyToCents(value) {
    if (value == null) return null;
    var s = String(value).trim();
    if (!s) return null;
    var n = parseFloat(s.replace(/[^0-9.-]/g, ''));
    if (isNaN(n)) return null;
    return Math.round(n * 100);
  }

  function parsePct(value) {
    if (value == null) return null;
    var s = String(value).trim();
    if (!s) return null;
    var n = parseFloat(s.replace(/[^0-9.-]/g, ''));
    if (isNaN(n)) return null;
    return n;
  }

  function packDisplayRow(catalog, sensors) {
    var ds = catalog && catalog.displaySettings;
    if (!ds || !ds.packs) return null;
    return ds.packs[String(sensors)] || null;
  }

  function dailyCostLabel(subscribePriceCents, days, moneyFormat) {
    if (!days) return '';
    return '\u2248 ' + formatMoney(Math.round(subscribePriceCents / days), moneyFormat) + '/day';
  }

  function enrichPack(pack, catalog) {
    pack.oneOffPrice = Number(pack.oneOffPrice) || 0;
    pack.subscribePrice = Number(pack.subscribePrice) || 0;
    pack.sensors = Number(pack.sensors) || 0;
    pack.oneOffPerSensor = perSensor(pack.oneOffPrice, pack.sensors);
    pack.subscribePerSensor = perSensor(pack.subscribePrice, pack.sensors);
    pack.listPrice = 0;
    pack.uiOneOffPrice = pack.oneOffPrice;
    pack.uiSubscribePrice = pack.subscribePrice;
    pack.oneOffSavePercent = 0;
    pack.subscribeSavePercent = 0;
    if (catalog && catalog.market === 'au' && catalog.oneSensorOneOffPrice) {
      pack.savePercent = savePercent(catalog.oneSensorOneOffPrice, pack.subscribePerSensor);
    } else if (catalog && catalog.market === 'nz' && catalog.oneSensorOneOffPrice) {
      pack.listPrice = catalog.oneSensorOneOffPrice * pack.sensors;
      var row = packDisplayRow(catalog, pack.sensors);
      var otTotal = row ? moneyToCents(row.onetimeTotal) : null;
      var subTotal = row ? moneyToCents(row.subscribeTotal) : null;
      var otPct = row ? parsePct(row.onetimePct) : null;
      var subPct = row ? parsePct(row.subscribePct) : null;
      if (otTotal != null) pack.uiOneOffPrice = otTotal;
      if (subTotal != null) pack.uiSubscribePrice = subTotal;
      pack.oneOffPerSensor = perSensor(pack.uiOneOffPrice, pack.sensors);
      pack.subscribePerSensor = perSensor(pack.uiSubscribePrice, pack.sensors);
      pack.oneOffSavePercent = otPct != null ? Math.round(otPct) : percentOffList(pack.listPrice, pack.uiOneOffPrice, 'floor');
      pack.subscribeSavePercent = subPct != null ? Math.round(subPct) : percentOffList(pack.listPrice, pack.uiSubscribePrice, 'round');
      pack.savePercent = pack.subscribeSavePercent;
    } else {
      pack.savePercent = savePercent(pack.oneOffPrice, pack.subscribePrice);
    }
    pack.hasSubscribe = pack.sellingPlanId != null && pack.sensors > 1;
  }

  function initPurchase(root) {
    var catalogEl = root.querySelector('[data-pd-air-catalog]');
    if (!catalogEl) return;

    var catalog = JSON.parse(catalogEl.textContent);
    var listFromEditor = catalog.displaySettings ? moneyToCents(catalog.displaySettings.listUnitPrice) : null;
    catalog.listUnitPriceCents = listFromEditor || 0;

    catalog.packs = (catalog.packs || []).map(function (p) {
      enrichPack(p, catalog);
      return p;
    }).sort(function (a, b) {
      return (a.sensors || 0) - (b.sensors || 0);
    });

    if (!catalog.packs.length) return;

    var oneSensor = catalog.packs.find(function (p) { return p.sensors === 1; });
    if (catalog.market === 'nz' && catalog.listUnitPriceCents > 0) {
      catalog.oneSensorOneOffPrice = catalog.listUnitPriceCents;
    } else if (oneSensor) {
      catalog.oneSensorOneOffPrice = oneSensor.oneOffPrice;
    }
    catalog.packs.forEach(function (p) { enrichPack(p, catalog); });

    var largestIdx = 0;
    catalog.packs.forEach(function (p, i) {
      if (p.sensors > catalog.packs[largestIdx].sensors) largestIdx = i;
    });

    var state = {
      packIndex: Math.min(largestIdx, catalog.packs.length - 1),
      mode: 'subscribe',
      qty: 1,
    };

    try {
      var urlVariant = Number(new URL(window.location.href).searchParams.get('variant') || 0);
      var urlIdx = catalog.packs.findIndex(function (p) { return p.variantId === urlVariant; });
      if (urlIdx >= 0) state.packIndex = urlIdx;
    } catch (e) { /* keep default pack */ }

    var variantInput = root.querySelector('[data-pd-air-variant-input]');
    var qtyInput = root.querySelector('[data-pd-air-qty-input]');
    var planInput = root.querySelector('[data-pd-air-selling-plan-input]');
    var skuEl = document.getElementById('pd-variant-sku');
    var form = root.closest('form');

    function currentPack() {
      return catalog.packs[state.packIndex] || catalog.packs[0];
    }

    function subscribePacks() {
      if (catalog.market === 'au') {
        return catalog.packs.filter(function (p) {
          return p.sensors > 1 && p.sellingPlanId;
        });
      }
      return catalog.packs.filter(function (p) {
        return p.sellingPlanId || p.savePercent > 0 || catalog.market === 'nz';
      });
    }

    function oneSensorPack() {
      return catalog.packs.find(function (p) {
        return p.sensors === 1;
      }) || catalog.packs[0];
    }

    function minSubscribePerSensor() {
      var subs = subscribePacks();
      if (!subs.length) return Math.min.apply(null, catalog.packs.map(function (p) { return p.oneOffPerSensor; }));
      return Math.min.apply(null, subs.map(function (p) { return p.subscribePerSensor; }));
    }

    function routePath(path) {
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (rootPath.slice(-1) !== '/') rootPath += '/';
      return rootPath + path.replace(/^\//, '');
    }

    function applySellingPlanUrlState(usePack, useSubscribe) {
      var addUrl = new URL(routePath('cart/add'), window.location.origin);
      addUrl.searchParams.set('variant', String(usePack.variantId));
      if (useSubscribe) addUrl.searchParams.set('selling_plan', String(usePack.sellingPlanId));

      if (form) {
        form.setAttribute('action', addUrl.pathname + addUrl.search);
      }

      if (!window.history || !window.history.replaceState) return;

      var pageUrl = new URL(window.location.href);
      pageUrl.searchParams.set('variant', String(usePack.variantId));
      if (useSubscribe) {
        pageUrl.searchParams.set('selling_plan', String(usePack.sellingPlanId));
      } else {
        pageUrl.searchParams.delete('selling_plan');
      }
      if (pageUrl.href !== window.location.href) {
        window.history.replaceState(window.history.state, '', pageUrl.href);
      }
    }

    function syncForm() {
      var pack = currentPack();
      var oneOff = catalog.market === 'au' && state.mode === 'onetime';
      var usePack = oneOff ? oneSensorPack() : pack;
      var lineQty = oneOff ? state.qty : 1;
      var useSubscribe = state.mode === 'subscribe' && usePack.sellingPlanId;

      if (variantInput) variantInput.value = usePack.variantId;
      if (qtyInput) qtyInput.value = String(lineQty);
      if (planInput) {
        if (useSubscribe) {
          planInput.value = String(usePack.sellingPlanId);
        } else {
          planInput.value = '';
        }
      }
      applySellingPlanUrlState(usePack, useSubscribe);
      if (skuEl && usePack.sku) skuEl.textContent = 'SKU: ' + usePack.sku;
    }

    function updateCta() {
      var label = root.querySelector('[data-pd-air-atc-label]');
      if (!label) return;
      var pack = currentPack();
      var total;
      if (catalog.market === 'au' && state.mode === 'onetime') {
        total = oneSensorPack().oneOffPrice * state.qty;
        label.textContent = 'Add to cart — ' + formatMoney(total, catalog.moneyFormat);
      } else if (state.mode === 'subscribe') {
        total = pack.subscribePrice;
        label.textContent = 'Start subscription — ' + formatMoney(total, catalog.moneyFormat);
      } else {
        total = pack.oneOffPrice * state.qty;
        label.textContent = 'Add to cart — ' + formatMoney(total, catalog.moneyFormat);
      }
    }

    function renderNz() {
      var pack = currentPack();
      var packRow = root.querySelector('[data-pd-air-pack-row]');
      if (packRow && !packRow.dataset.built) {
        packRow.dataset.built = '1';
        catalog.packs.forEach(function (p, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'pd-caresens-air-purchase__pack-pill';
          btn.setAttribute('role', 'radio');
          btn.dataset.packIndex = String(i);
          if (i === catalog.packs.length - 1 && p.sensors >= 6) {
            var pop = document.createElement('span');
            pop.className = 'pd-caresens-air-purchase__pack-pop';
            pop.textContent = 'Best value';
            btn.appendChild(pop);
          }
          var days = document.createElement('span');
          days.className = 'pd-caresens-air-purchase__pp-days';
          days.textContent = p.days + ' days';
          var sensors = document.createElement('span');
          sensors.className = 'pd-caresens-air-purchase__pp-sensors';
          sensors.textContent = p.sensors + (p.sensors === 1 ? ' sensor' : ' sensors');
          btn.appendChild(days);
          btn.appendChild(sensors);
          btn.addEventListener('click', function () {
            state.packIndex = i;
            render();
          });
          packRow.appendChild(btn);
        });
      }

      root.querySelectorAll('[data-pd-air-pack-row] .pd-caresens-air-purchase__pack-pill').forEach(function (btn, i) {
        var on = i === state.packIndex;
        btn.classList.toggle('pd-caresens-air-purchase__pack-pill--active', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      var otPer = root.querySelector('[data-pd-air-ot-persensor]');
      var otTotal = root.querySelector('[data-pd-air-ot-total]');
      var otStrike = root.querySelector('[data-pd-air-ot-strike]');
      var otBadge = root.querySelector('[data-pd-air-ot-badge]');
      var subPer = root.querySelector('[data-pd-air-sub-persensor]');
      var subTotal = root.querySelector('[data-pd-air-sub-total]');
      var subStrike = root.querySelector('[data-pd-air-sub-strike]');
      var badge = root.querySelector('[data-pd-air-sub-badge]');
      var listMoney = formatMoney(pack.listPrice, catalog.moneyFormat);

      function setSaveBadge(el, pct) {
        if (!el) return;
        if (pct > 0) {
          el.hidden = false;
          el.textContent = 'Save ' + pct + '% vs. single sensor';
          el.classList.remove('pd-caresens-air-purchase__opt-badge--neutral');
        } else {
          el.hidden = true;
          el.textContent = '';
        }
      }

      function setListStrike(el, pct) {
        if (!el) return;
        if (pct > 0 && pack.listPrice > 0) {
          el.hidden = false;
          el.textContent = listMoney;
        } else {
          el.hidden = true;
        }
      }

      if (otPer) otPer.innerHTML = formatMoney(pack.oneOffPerSensor, catalog.moneyFormat) + '<span class="pd-caresens-air-purchase__ps-unit">&nbsp;/ sensor</span>';
      if (otTotal) otTotal.textContent = formatMoney(pack.uiOneOffPrice, catalog.moneyFormat) + ' total';
      if (subPer) subPer.innerHTML = formatMoney(pack.subscribePerSensor, catalog.moneyFormat) + '<span class="pd-caresens-air-purchase__ps-unit">&nbsp;/ sensor</span>';
      if (subTotal) subTotal.textContent = formatMoney(pack.uiSubscribePrice, catalog.moneyFormat) + ' total';
      setListStrike(otStrike, pack.oneOffSavePercent);
      setListStrike(subStrike, pack.subscribeSavePercent);
      setSaveBadge(otBadge, pack.oneOffSavePercent);
      setSaveBadge(badge, pack.subscribeSavePercent);

      root.querySelectorAll('[data-pd-air-mode]').forEach(function (btn) {
        var on = btn.dataset.pdAirMode === state.mode;
        btn.classList.toggle('pd-caresens-air-purchase__opt-card--active', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      var subDetail = root.querySelector('[data-pd-air-sub-detail]');
      var subNudge = root.querySelector('[data-pd-air-sub-nudge]');
      if (subDetail) subDetail.hidden = state.mode !== 'subscribe';
      if (subNudge) subNudge.hidden = state.mode === 'subscribe';

      var delivery = root.querySelector('[data-pd-air-delivery-text]');
      if (delivery) {
        delivery.innerHTML = 'Your <strong>' + pack.sensors + '-sensor pack</strong> delivered automatically every <strong>' + pack.days + ' days</strong>.';
      }
      var nudgeSub = root.querySelector('[data-pd-air-nudge-sub]');
      if (nudgeSub) {
        nudgeSub.textContent = pack.subscribeSavePercent > 0
          ? 'Save ' + pack.subscribeSavePercent + '% and have it auto-delivered before you run low.'
          : 'Have it auto-delivered every ' + pack.days + ' days so you never run out.';
      }

      var qtyBlock = root.querySelector('.pd-caresens-air-purchase__qty-block');
      if (qtyBlock) qtyBlock.hidden = state.mode === 'subscribe';

      var cartRow = root.querySelector('.pd-caresens-air-purchase__cart-row');
      if (cartRow) {
        cartRow.classList.toggle('pd-caresens-air-purchase__cart-row--has-qty', state.mode === 'onetime');
      }
    }

    function renderAu() {
      var subs = subscribePacks();
      if (state.mode === 'subscribe' && subs.length) {
        var idx = subs.findIndex(function (p) {
          return catalog.packs[state.packIndex] === p;
        });
        if (idx === -1) state.packIndex = catalog.packs.indexOf(subs[subs.length - 1]);
      }

      var pack = currentPack();
      var one = oneSensorPack();

      var planGrid = root.querySelector('[data-pd-air-au-plan-grid]');
      if (planGrid && !planGrid.dataset.built) {
        planGrid.dataset.built = '1';
        subs.forEach(function (p) {
          var i = catalog.packs.indexOf(p);
          var card = document.createElement('button');
          card.type = 'button';
          card.className = 'pd-caresens-air-purchase__plan-card';
          card.dataset.packIndex = String(i);
          if (p.sensors >= 6) {
            card.classList.add('pd-caresens-air-purchase__plan-card--tagged');
          }
          card.innerHTML =
            (p.sensors >= 6 ? '<span class="pd-caresens-air-purchase__plan-tag">Best value</span>' : '') +
            '<p class="pd-caresens-air-purchase__plan-supply">' + p.days + ' days</p>' +
            '<p class="pd-caresens-air-purchase__plan-sensors">' + p.sensors + ' sensors</p>' +
            '<p class="pd-caresens-air-purchase__plan-per">' + formatMoney(p.subscribePerSensor, catalog.moneyFormat) + '</p>' +
            '<p class="pd-caresens-air-purchase__plan-per-label">per sensor</p>' +
            '<span class="pd-caresens-air-purchase__plan-pct">' + p.savePercent + '% off</span>' +
            '<p class="pd-caresens-air-purchase__plan-day">' + dailyCostLabel(p.subscribePrice, p.days, catalog.moneyFormat) + '</p>';
          card.addEventListener('click', function (e) {
            e.stopPropagation();
            state.packIndex = i;
            state.mode = 'subscribe';
            render();
          });
          planGrid.appendChild(card);
        });
      }

      root.querySelectorAll('[data-pd-air-au-plan-grid] .pd-caresens-air-purchase__plan-card').forEach(function (card) {
        card.classList.toggle('pd-caresens-air-purchase__plan-card--active', Number(card.dataset.packIndex) === state.packIndex);
      });

      var saving = (catalog.oneSensorOneOffPrice * pack.sensors) - pack.subscribePrice;
      var perSaving = pack.sensors ? Math.round(saving / pack.sensors) : 0;

      var el;
      if ((el = root.querySelector('[data-pd-air-au-sub-head-per]'))) el.textContent = formatMoney(pack.subscribePerSensor, catalog.moneyFormat);
      if ((el = root.querySelector('[data-pd-air-au-sub-head-total]'))) el.textContent = formatMoney(pack.subscribePrice, catalog.moneyFormat) + ' total\u00a0· ' + pack.sensors + ' sensors';
      if ((el = root.querySelector('[data-pd-air-au-save-badge]'))) el.textContent = 'Save ' + pack.savePercent + '%';
      if ((el = root.querySelector('[data-pd-air-au-pct-note]'))) el.textContent = '% off the one-off (single sensor) price of ' + formatMoney(catalog.oneSensorOneOffPrice, catalog.moneyFormat);
      if ((el = root.querySelector('[data-pd-air-au-perk-saving]'))) el.textContent = 'Save ' + formatMoney(saving, catalog.moneyFormat) + ' (' + formatMoney(perSaving, catalog.moneyFormat) + ' per sensor) vs buying one-off';
      if ((el = root.querySelector('[data-pd-air-au-perk-cadence]'))) el.textContent = pack.sensors + ' sensors delivered every ' + pack.days + ' days';
      if ((el = root.querySelector('[data-pd-air-au-ot-head-price]'))) el.textContent = formatMoney(one.oneOffPrice, catalog.moneyFormat);
      if ((el = root.querySelector('[data-pd-air-au-ot-total]'))) el.textContent = formatMoney(one.oneOffPrice * state.qty, catalog.moneyFormat);
      if ((el = root.querySelector('[data-pd-air-au-ot-total-label]'))) el.textContent = state.qty + (state.qty === 1 ? ' sensor' : ' sensors');

      root.querySelectorAll('[data-pd-air-au-card]').forEach(function (card) {
        var mode = card.dataset.pdAirAuCard;
        card.classList.toggle('pd-caresens-air-purchase__buy-card--active', mode === state.mode);
      });
    }

    function render() {
      var hero = root.querySelector('[data-pd-air-hero-price]');
      if (hero) hero.textContent = formatMoney(minSubscribePerSensor(), catalog.moneyFormat);

      if (catalog.market === 'au') renderAu();
      else renderNz();

      root.querySelectorAll('[data-pd-air-qty-display]').forEach(function (el) {
        el.textContent = String(state.qty);
      });

      syncForm();
      updateCta();
    }

    root.querySelectorAll('[data-pd-air-mode]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.mode = btn.dataset.pdAirMode;
        render();
      });
    });

    root.querySelectorAll('[data-pd-air-au-mode]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.mode = btn.dataset.pdAirAuMode;
        render();
      });
    });

    root.querySelectorAll('[data-pd-air-qty-inc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.qty += 1;
        render();
      });
    });

    root.querySelectorAll('[data-pd-air-qty-dec]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.qty = Math.max(1, state.qty - 1);
        render();
      });
    });

    var nudgeSwitch = root.querySelector('[data-pd-air-nudge-switch]');
    if (nudgeSwitch) {
      nudgeSwitch.addEventListener('click', function () {
        state.mode = 'subscribe';
        render();
      });
    }

    function refreshOneOffFromProductJson() {
      var handle = catalog.productHandle;
      if (!handle) return;
      fetch(routePath('products/' + encodeURIComponent(handle) + '.js'), { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (product) {
          if (!product || !product.variants) return;
          var changed = false;
          product.variants.forEach(function (variant) {
            var pack = catalog.packs.find(function (p) { return p.variantId === variant.id; });
            if (!pack || typeof variant.price !== 'number') return;
            if (pack.oneOffPrice !== variant.price) {
              pack.oneOffPrice = variant.price;
              enrichPack(pack, catalog);
              changed = true;
            }
          });
          var one = catalog.packs.find(function (p) { return p.sensors === 1; });
          if (catalog.market === 'nz' && catalog.listUnitPriceCents > 0) {
            catalog.oneSensorOneOffPrice = catalog.listUnitPriceCents;
            catalog.packs.forEach(function (p) { enrichPack(p, catalog); });
          } else if (one) {
            catalog.oneSensorOneOffPrice = one.oneOffPrice;
            catalog.packs.forEach(function (p) { enrichPack(p, catalog); });
          }
          if (changed) render();
        })
        .catch(function () { /* keep Liquid catalogue prices */ });
    }

    render();
    refreshOneOffFromProductJson();
  }

  function boot() {
    document.querySelectorAll('.pd-caresens-air-purchase').forEach(initPurchase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
